module.exports = __webpack_public_path__ + "SourceSansPro-BoldItalic.c7658e885fb34ed76de9.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-BoldItalic.eot
// module id = ../../../../../src/assets/customfonts/SourceSansPro-BoldItalic.eot
// module chunks = styles